import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";

/**
 * Step-one submission for the flexible ("split") payment flow.
 * POST /split-payment/create — persists the buyer's info + selected add-ons
 * (warranty, road service) and opens the split-payment order server-side.
 */

export var api__createSplitPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(requestData) {
    var form, response;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          form = new URLSearchParams();
          form.set("post_id", String(requestData.post_id));
          form.set("first_name", requestData.first_name);
          if (requestData.last_name != null) form.set("last_name", requestData.last_name);
          form.set("phone_number", requestData.phone_number);
          form.set("city_id", String(requestData.city_id));
          if (requestData.whatsapp_optin != null) form.set("whatsapp_optin", String(requestData.whatsapp_optin));
          if (requestData.warranty_id != null) form.set("warranty_id", String(requestData.warranty_id));
          if (requestData.road_service_id != null) form.set("road_service_id", String(requestData.road_service_id));
          _context.n = 1;
          return fetcher().post("/split-payment/create", form);
        case 1:
          response = _context.v;
          return _context.a(2, response === null || response === void 0 ? void 0 : response.data);
      }
    }, _callee);
  }));
  return function api__createSplitPayment(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Step-two payment options for the entered cash amount.
 * GET /split-payment/options?amount&order_id — returns the installment-method
 * cards to render plus a status message (shown as the note in the cash modal).
 * Called with amount=0 when step two opens, then re-called as the buyer types.
 */

export var api__getSplitPaymentOptions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestData) {
    var _response$data, _data$paymentMethodSe, _data$message;
    var params, response, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          // Don't send `amount` until the buyer actually enters one (initial step-two
          // load) — the backend returns the default options when it's absent.
          params = {
            order_id: requestData.order_id
          };
          if (requestData.amount != null && requestData.amount > 0) params.amount = requestData.amount;
          _context2.n = 1;
          return fetcher().get("/split-payment/options", {
            params: params
          });
        case 1:
          response = _context2.v;
          data = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data;
          return _context2.a(2, {
            paymentMethodSections: (_data$paymentMethodSe = data === null || data === void 0 ? void 0 : data.paymentMethodSections) !== null && _data$paymentMethodSe !== void 0 ? _data$paymentMethodSe : [],
            message: (_data$message = data === null || data === void 0 ? void 0 : data.message) !== null && _data$message !== void 0 ? _data$message : null,
            has_message: Boolean(data === null || data === void 0 ? void 0 : data.has_message)
          });
      }
    }, _callee2);
  }));
  return function api__getSplitPaymentOptions(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Step-two checkout — opens the chosen provider's session for the split.
 * POST /split-payment/checkout with the cash the buyer pays now, the remainder
 * financed via `provider` (amwal | tabby | tamara). Returns the provider's
 * `checkout_url` to redirect to; success/failure/cancel bounce back to the
 * matching /split-payment result route.
 */

export var api__splitPaymentCheckout = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(requestData) {
    var response;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return fetcher().post("/split-payment/checkout", requestData);
        case 1:
          response = _context3.v;
          return _context3.a(2, response === null || response === void 0 ? void 0 : response.data);
      }
    }, _callee3);
  }));
  return function api__splitPaymentCheckout(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Result-screen summary for a completed split-payment order.
 * GET /split-payment/summary?order_id — drives the success screen (paid amount
 * via the provider + remaining cash label/amount).
 */

export var api__getSplitPaymentSummary = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(orderId, provider) {
    var _data, _response$data2;
    var params, response;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          params = {
            order_id: orderId
          };
          if (provider) params.provider = provider;
          _context4.n = 1;
          return fetcher().get("/split-payment/summary", {
            params: params
          });
        case 1:
          response = _context4.v;
          return _context4.a(2, (_data = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.data) !== null && _data !== void 0 ? _data : null);
      }
    }, _callee4);
  }));
  return function api__getSplitPaymentSummary(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Cancel a pending amwal split-payment session (split-payment clone of
 * /amwal/cancel-order). A session left "pending" means the buyer bailed out of
 * the provider checkout — canceling flips the summary's session_status to
 * "canceled" so the result routing resolves to cancel.
 */
export var api__cancelAmwalSplitOrder = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(requestData) {
    var _requestData$provider, _response$data3;
    var formData, response;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          formData = new URLSearchParams();
          formData.set("order_id", String(requestData.order_id));
          formData.set("status", requestData.status);
          formData.set("provider", (_requestData$provider = requestData.provider) !== null && _requestData$provider !== void 0 ? _requestData$provider : "amwal");
          _context5.n = 1;
          return fetcher().post("/split-payment/cancel-order", formData);
        case 1:
          response = _context5.v;
          if (!(response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.success)) {
            _context5.n = 2;
            break;
          }
          return _context5.a(2, response.data);
        case 2:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return function api__cancelAmwalSplitOrder(_x6) {
    return _ref5.apply(this, arguments);
  };
}();